/**
 * "Load more" button handler for price lists.
 * Shows hidden price rows progressively (10 at a time).
 */

const PRICES_PER_LOAD = 10;

/**
 * Setup "Load more" button click handlers
 */
export function setupLoadMorePrices() {
    document.addEventListener('click', (e) => {
        const btn = (e.target as HTMLElement).closest('.btn-load-more-prices');
        if (!btn) return;

        const container = btn.closest('.price-list-container');
        if (!container) return;

        const hiddenRows = container.querySelectorAll<HTMLElement>('tr.price-overflow.d-none');
        const toShow = Array.from(hiddenRows).slice(0, PRICES_PER_LOAD);
        toShow.forEach(row => row.classList.remove('d-none'));

        // Hide button if no more hidden rows
        if (container.querySelectorAll('tr.price-overflow.d-none').length === 0) {
            (btn as HTMLElement).classList.add('d-none');
        }
    });
}
